module.exports = __webpack_public_path__ + "static/img/长筒袜.bd24bc81.jpg";